.ux-async-html {
  display: none;

  &--content-loaded {
    display: block;
  }
}
